import { HttpClient } from "../../common/api/http-client";
import { injectable } from "@servicetitan/react-ioc";

@injectable()
export class TermsOfUseApi {
    constructor(private readonly httpClient: HttpClient) {}

    getTermsOfUse() {
        return this.httpClient.get<string>('/account/terms-of-use');
    }

    acceptTermsOfUse() {
        return this.httpClient.post('/account/terms-of-use/accept');
    }
}